// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"54613e131babab03f59a","303":"c217a7d629bd0c18cfbf","495":"3ed34d958ce859075e9f"}[chunkId] + ".js";
};